import { Chart, ChartDataSets } from "chart.js";
import GraphContent from "../../../components/graphContent/graph_content";

export class ChartFactory {

  public static factoryChartData(
    timeData: string[],
    datasets: ChartDataSets[],
  ): Chart.ChartData {
    return {
      labels: timeData,
      datasets,
    };
  }

  public static createLineChartDatasets(
    labels: string[],
    data: number[][],
    latestAttributeValues: {[key: string]: string | number},
    colors: string[],
    type: string,
    threshold?: GraphContent["dynamoThreshold"],
  ): ChartDataSets[] {
    const dataSetsArray: ChartDataSets[] = [];
    const maxLineColor = "rgba(255, 10, 10, 1)";
    const minLineColor = "rgba(10, 10, 255, 1)";

    // 上限のライン描画
    if (threshold.max.enabled) {
      const rowData: number[] = data[0].map(() => {
        return Number(threshold.max.value);
      });
      const arrayContents: { [key: string]: any } = {
        type: "line",
        label: "上限",
        data: rowData,
        backgroundColor: maxLineColor,
        fill: false,
        borderWidth: 2,
        borderColor: maxLineColor,
        radius: 0,
      };
      dataSetsArray.push(arrayContents);
    }

    // 下限のライン描画
    if (threshold.min.enabled) {
      const rowData: number[] = data[0].map(() => {
        return Number(threshold.min.value);
      });
      const arrayContents: { [key: string]: any } = {
        type: "line",
        label: "下限",
        data: rowData,
        backgroundColor: minLineColor,
        fill: false,
        borderWidth: 2,
        borderColor: minLineColor,
        radius: 0,
      };
      dataSetsArray.push(arrayContents);
    }

    labels.forEach((label, index) => {
      latestAttributeValues[label] = String(data[index][data[index].length - 1]);
      const arrayContents: { [key: string]: any } = {
        type: "line",
        label,
        data: data[index],
        backgroundColor: colors[index],
        fill: false,
        borderWidth: 2,
        borderColor: colors[index],
        radius: 0,
      };
      if (type === "line") {
        arrayContents.lineTension = 0;
      }
      dataSetsArray.push(arrayContents);
    });
    return dataSetsArray;
  }
}
